import { render } from "./InactivarLabImgCSV.vue?vue&type=template&id=d6353b90&scoped=true"
import script from "./InactivarLabImgCSV.vue?vue&type=script&lang=js"
export * from "./InactivarLabImgCSV.vue?vue&type=script&lang=js"

import "./InactivarLabImgCSV.vue?vue&type=style&index=0&id=d6353b90&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6353b90"]])

export default __exports__